import PrincipalEditorEmailSetting from './principal-editor-emailsetting';

export default PrincipalEditorEmailSetting;